module.exports = __webpack_public_path__ + "static/media/599.756(1).5afe991d.pdf";